import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	productStore: {
		id: 'cross-flow-support.product-store',
		defaultMessage: 'Product store',
		description: 'Used as a header for the Atlassian Product store',
	},
	backToAllProducts: {
		id: 'cross-flow-support.back-to-all-products',
		defaultMessage: 'Back to all products',
		description: 'A label for a back arrow button',
	},
	close: {
		id: 'cross-flow-support.close',
		defaultMessage: 'Close',
		description: 'A label for a button to close the Product store',
	},
});
